module.exports = __webpack_public_path__ + "img/trail-icon.c5c62f13.png";